import * as React from "react";

import { IconProps } from "./types";

const PlayIcon = ({ width = 17, height = 20, className }: IconProps) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="-4 -2 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m1.333 1 14 9-14 9V1Z"
      stroke="inherit"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PlayIcon;
